module.exports = "\n.btn-primary{\n    width: 102px !important;\n}\n"